"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSelect = LocationSelect;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const lodash_1 = require("lodash");
const Api = __importStar(require("@src/api"));
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("@src/types");
const normalize_string_1 = require("@src/helpers/normalize-string");
const SelectTag_1 = require("@src/components/elements/SelectTag/SelectTag");
const elements_1 = require("@src/components/elements");
const IconStyled = (0, styled_components_1.default)(elements_1.Icon) `
	z-index: 2;
	top: 30%;
	left: 8px;

	svg {
		width: 16px;
		margin-right: 4px;
	}
`;
function buildLocationTreeData(currentSubhierarchy, intl) {
    return currentSubhierarchy.map(location => {
        var _a;
        const result = {
            title: intl.formatMessage({
                id: `${location.translation_key}`,
            }),
            value: location.id,
        };
        if ((_a = location.sublocations) === null || _a === void 0 ? void 0 : _a.length) {
            result.children = buildLocationTreeData(location.sublocations, intl);
        }
        return result;
    });
}
function LocationSelect({ value, onChange, locationTree, isLoading, className, placeholder, maxSearchLength = 27, setShowLocationPlaceholder, }) {
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const [fetchedHierarchicalLocations, setFetchedHierarchicalLocations] = react_1.default.useState([]);
    const [locationHierarchy, setLocationHierarchy] = react_1.default.useState([]);
    const [inputValue, setInputValue] = react_1.default.useState('');
    const intl = (0, react_intl_1.useIntl)();
    function showErrorNotification() {
        antd_1.notification.error({
            message: intl.formatMessage({ id: 'general.error' }),
            description: intl.formatMessage({ id: 'general.something_went_wrong' }),
        });
    }
    async function initialize() {
        try {
            if (locationTree) {
                setLocationHierarchy(locationTree);
            }
            else {
                const newFetchedHierarchicalLocations = await Api.Location.getHierarchicalLocations();
                setFetchedHierarchicalLocations(newFetchedHierarchicalLocations);
            }
            setIsInitialized(true);
        }
        catch (err) {
            console.error(err);
            showErrorNotification();
        }
    }
    react_1.default.useEffect(() => {
        initialize();
    }, []);
    react_1.default.useEffect(() => {
        setLocationHierarchy([
            {
                title: intl.formatMessage({ id: 'location.abroad' }),
                value: types_1.ABROAD,
            },
            {
                title: intl.formatMessage({ id: 'location.remote' }),
                value: types_1.REMOTE,
            },
            ...buildLocationTreeData(fetchedHierarchicalLocations, intl),
        ]);
    }, [fetchedHierarchicalLocations, intl]);
    react_1.default.useEffect(() => {
        if (locationTree && !(0, lodash_1.isEqual)(locationTree, locationHierarchy)) {
            setLocationHierarchy(locationTree);
        }
    }, [locationTree]);
    const defaultExpandedKeys = react_1.default.useMemo(() => {
        const startOfHierarchy = locationHierarchy.find(node => node.value !== types_1.ABROAD && node.value !== types_1.REMOTE);
        return startOfHierarchy ? [startOfHierarchy.value] : [];
    }, [locationHierarchy]);
    function handleChange(locations) {
        onChange === null || onChange === void 0 ? void 0 : onChange(locations);
        if (!locationTree && setShowLocationPlaceholder) {
            setShowLocationPlaceholder(!locations.length);
        }
    }
    function filterTreeNode(val, treeNode) {
        return (0, normalize_string_1.normalizeStr)(treeNode.title).indexOf((0, normalize_string_1.normalizeStr)(val)) >= 0;
    }
    react_1.default.useEffect(() => {
        if (setShowLocationPlaceholder && !inputValue) {
            setShowLocationPlaceholder(true);
        }
    }, [inputValue]);
    return ((0, jsx_runtime_1.jsx)(elements_1.TreeSelect, { className: className, treeNodeFilterProp: "title", treeDefaultExpandedKeys: defaultExpandedKeys, filterTreeNode: filterTreeNode, value: value, loading: !isInitialized || isLoading, showArrow: true, style: { width: '100%' }, listHeight: 360, treeData: locationHierarchy, placeholder: placeholder, multiple: true, treeCheckable: true, showCheckedStrategy: elements_1.TreeSelect.SHOW_PARENT, maxTagCount: "responsive", searchValue: inputValue, onSearch: val => {
            setInputValue(val.substring(0, maxSearchLength));
            if (setShowLocationPlaceholder && val) {
                setShowLocationPlaceholder(false);
            }
        }, 
        // @ts-ignore
        onChange: handleChange, onBlur: () => setInputValue(''), tagRender: tagProps => ((0, jsx_runtime_1.jsx)(SelectTag_1.SelectTag, { loading: Boolean(isLoading || !isInitialized), ...tagProps, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-inline align-center", children: [(0, jsx_runtime_1.jsx)(IconStyled, { type: "pin-location" }), tagProps.label] }) })) }));
}
